<template>
  <van-tabbar v-model="type" @change="onChange" active-color="#cf866b" inactive-color="#000" style="border-top: 1px solid #d5d8e0; box-sizing: border-box; background-color: rgb(243, 246, 255); z-index: 200">
    <!-- 0 视频（原直播） -->
    <van-tabbar-item>
      <span>视频</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tabbar_icon4_select.png' : '/static/image/tabbar_icon4_nor.png'" />
      </template>
    </van-tabbar-item>
    <!-- 1 娱乐（原首页） -->
    <van-tabbar-item>
      <span>娱乐</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tabbar_icon1_select.png' : '/static/image/tabbar_icon1_nor.png'" />
      </template>
    </van-tabbar-item>
    <!-- ========== 优惠 已隐藏，删除/注释此块 ==========
    <van-tabbar-item>
      <span>优惠</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tabbar_icon3_select.png' : '/static/image/tabbar_icon3_nor.png'" />
      </template>
    </van-tabbar-item>
    -->
    <!-- 2 客服（原来下标3，现在前移变成2） -->
    <van-tabbar-item>
      <span>客服</span>
      <template #icon="props">
       <img :src="props.active ? '/static/image/tabbar_icon6_select.png' : '/static/image/tabbar_icon6_nor.png'" />
      </template>
    </van-tabbar-item>
    <!-- 3 我的（原来下标4，现在前移变成3） -->
    <van-tabbar-item>
      <span>我的</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tabbar_icon5_select.png' : '/static/image/tabbar_icon5_nor.png'" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
export default {
  name: 'Foot',
  data() {
    return { type: 0 };
  },
  methods: {
    onChange(type) {
      let that = this;
      if (type == 0) {
        //视频 = 直播页面 /zhibo
        that.$parent.goNav(`/zhibo`);
      }
      if (type == 1) {
        //娱乐（原首页）
        that.$parent.goNav(`/index`);
      }
      // 优惠type=2 移除
      if (type == 2) {
        //客服（原type3）
        that.$parent.openKefu();
      }
      if (type == 3) {
        //我的（原type4）
        that.$parent.goNav(`/mine`);
      }
    },
    changPath() {
      let that = this;
      let path = this.$route.path;
      //视频
      if (path == '/zhibo') {
        that.type = 0;
      }
      //娱乐（首页）
      if (path == '/index') {
        that.type = 1;
      }
      // if (path == '/activity') {
      //   that.type = 2;
      // }
      if (path == '/kefu') {
        that.type = 2;
      }
      if (path == '/mine') {
        that.type = 3;
      }
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.changPath();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.van-tabbar-item__icon img {
  display: block;
  height: 34px;
}
.van-tabbar-item {
  font-size: 14px;
}
.van-tabbar {
  height: 68px;
}
.van-tabbar-item--active {
  background-color: rgb(243, 246, 255);
}
</style>


// WEBPACK FOOTER //
// src/components/libs/Foot.vue